export default {
    storageOptions: {
        namespace: 'evo_health_h5__', // key prefix
        name: 'ls', // name variable Vue.[ls] or this.[$ls],
        storage: 'local', // storage name session, local, memory
    }
}